<template>
    <course-quiz
        :type="type"
        :namespace="namespace"
        :uuid="uuid"
        :has-submissions="hasSubmissions"
        read-only
        :activity="activity"
    />
</template>

<script>
import Quiz from '@/components/activity-types/course-activity-types/activities/quiz/Quiz.vue';

export default {
    name: 'CourseActivitySurvey',

    components: { CourseQuiz: Quiz },

    props: {
        namespace: {
            type: String,
            default: null,
        },

        uuid: {
            type: String,
            default: null,
        },

        type: {
            type: String,
            default: 'survey',
        },

        hasSubmissions: {
            required: false,
            type: Boolean,
            default: false,
        },

        activity: {
            type: Object,
            required: true,
        },
    },
};
</script>
